import { render, staticRenderFns } from "./rfq-tab-audit.vue?vue&type=template&id=ed18041e"
import script from "./rfq-tab-audit.vue?vue&type=script&lang=js"
export * from "./rfq-tab-audit.vue?vue&type=script&lang=js"
import style0 from "./rfq-tab-audit.vue?vue&type=style&index=0&id=ed18041e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports